import React from 'react';
import styled from 'styled-components';
//Import Icons
import Icon from '@ailibs/feather-react-ts';

//BOTONES CARD----
export const Buttons = styled.button`
    display: flex;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 4%;
    border: 0px;
    flex-direction: row-reverse;
    margin-top: 2%;
`;

export const AddButton = styled.button`
    width: 80px;
    height: 60px;
    right: 7%;
`;

export const CancelButton = styled.button`
    width: 85px;
    height: 48px;
`;

export const UpdateButton = styled.button`
    width: 85px;
    height: 48px;
    &:disabled {
        background-color: #e0e0e0;
        color: #999;
        cursor: not-allowed;
    }
`;

export const DeleteButton = styled.button`
    width: 85px;
    height: 48px;
`;
export const SearchButton = styled.button`
    width: 90px;
    height: 48px;
`;
export const CancelSearchButton = styled.button`
    width: 90px;
    height: 48px;
`;
export const TestingButton = styled.button`
    width: 85px;
    height: 48px;
    margin-right: 5%;
    &:disabled {
        background-color: #e0e0e0;
        color: #999;
        cursor: not-allowed;
    }
`;

//CONTENIDO CARD
const ContentContainer = styled.div`
    padding: 0px;
    display: grid;
`;

const Mytitle = styled.h1`
    display: flex;
    flex-direction: row;
    font-size: 23px;
    color: #ffffff;
    font-weight: normal;
    padding: 10px 0 10px 30px;
    margin-bottom:0px;
    svg {
        width: 5%;
        height: 5%;
        max-width: 30px;
        max-height: 30px;
        margin-right: 5px;
        margin-bottom: 5px;
    }
`;

const Overlay = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0%;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.6) !important;
    padding: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: 'auto';
    z-index: 100000;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: 30px;
    width: 20px;
    height: 20px;
    border: none;
    background: none;
    cursor: pointer;
    transition: 0.3s ease alll;
    border-radius: 5px;
    color: #ffffff;

    &:hover {
        background: #404040;
    }

    svg {
        width: 100%;
        height: 100%;
    }
`;

const Container = styled.div`
    min-width: 750px;
    max-width: 750px;
    min-height: 650px;
    max-height: 650px;
    background: #fff;
    position: fixed;
    border-radius: 30px;
    -webkit-box-shadow: 0px 0px 30px 10px #999999;
    -moz-box-shadow: 0px 0px 30px 10px #999999;
    box-shadow: 0px 0px 15px 9px #999999;
    z-index: 100000;
`;

export const IPopUp = ({
    children,
    stateAdd,
    stateUpdate,
    switchStateAdd,
    switchStateUpdate,
    stateTest,
    modalTitleAdd,
    modaleTitleUpdate,
    icon,
    colorHeaderPop,
    height,
    width,
}: any) => {
    const HeaderContainer = styled.div`
        border-radius: 30px 30px 0 0;
        background-color: ${colorHeaderPop} !important;
    `;

    return (
        <>
            {stateAdd && (
                <Overlay>
                    <Container className="iPopContainer" style={{ maxWidth: width || '750px', maxHeight: height || '650px', minWidth: width || '750px', minHeight: height || '650px', overflow: "hidden" }}>
                        {/* <Header> */}
                        <HeaderContainer>
                            <Mytitle style={{ marginLeft: '5px' }}>
                                <Icon name={icon} />
                                {modalTitleAdd}
                            </Mytitle>
                            {/* </Header> */}
                            <CloseButton onClick={() => switchStateAdd(!stateAdd)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="160"
                                    height="160"
                                    fill="currentColor"
                                    className="bi bi-x-lg"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                                </svg>
                            </CloseButton>
                        </HeaderContainer>
                        <ContentContainer className="ContentContainerIpopup">{children}</ContentContainer>
                    </Container>
                </Overlay>
            )}
            {stateUpdate && (
                <Overlay>
                    <Container>
                        {/* <Header> */}
                        <HeaderContainer className="iPopTitle">
                            <Mytitle>
                                <Icon name={icon} />
                                {modaleTitleUpdate}
                            </Mytitle>
                            {/* </Header> */}
                            <CloseButton onClick={() => switchStateUpdate(!stateUpdate)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-x-lg"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                                </svg>
                            </CloseButton>
                        </HeaderContainer>
                        <ContentContainer className="formContainer">{children}</ContentContainer>
                    </Container>
                </Overlay>
            )}
            {stateTest && (
                <div style={{ border: "1px solid gray", width: "555px", height: "500px", borderRadius: "31px 31px 30px 30px", overflow: "hidden" }}>
                    <HeaderContainer >
                        <Mytitle className='d-flex justify-content-center align-items-center'>
                            <i className="bx bx-palette"></i>
                            {modalTitleAdd}
                        </Mytitle>
                    </HeaderContainer>
                    <ContentContainer className="ContentContainerIpopup">{children}</ContentContainer>
                </div>
            )}

        </>
    );
};